import { MDBContainer } from 'mdbreact';
import React from 'react';
import { connect } from 'react-redux';
import BasePureComponent, { BasePureComponentProps } from '../../components/Shared/BasePureComponent';
import Layout from '../../components/Shared/Layout';
import { Language } from '../../redux/store/base/language';

import Vedio from '../../components/Vedio/Vedio';
import Comment from '../../components/Comment/Comment';
import Footer from '../../components/Footer/Footer';

import Header from './Header/Header';
import Info from './Info/Info';
import Subscription from "./Subscription/Subscription";

// Import asset
import "./Offer.scss";

class Offer extends BasePureComponent<OfferProps> {
    constructor(props: OfferProps) {
        super(props);
    }
    render() {
        return <Layout title={this.props.title}>
            <MDBContainer className="component offer" fluid>
                <Header />
                <Info />
                <Subscription />
                <Vedio />
                <Comment />
                <Footer />
            </MDBContainer>
        </Layout>
    }
}

function mapStateToProps(state) {
    return {
        lang: state.lang.dictionary as Language,
    }
}

interface OfferProps extends BasePureComponentProps {
    title: string;
}

export default connect(mapStateToProps)(Offer);